"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var ProjectTypes_1 = require("../ProjectTypes");
var Configurator_1 = __importDefault(require("../NavigationMenu/Configurator/Configurator"));
var IsBlockBrowser_1 = require("Project/BlockNew/IsBlockBrowser");
var GuessBlockName_1 = require("Project/BlockNew/GuessBlockName");
var ProjectNavigation = (function () {
    function ProjectNavigation(make, projectStore, telemetry, blockList) {
        var _this = this;
        this.make = make;
        this.projectStore = projectStore;
        this.telemetry = telemetry;
        this.blockList = blockList;
        this.configure = function () {
            return _this.make(Configurator_1.default, { projectStore: _this.projectStore });
        };
        this.isWidgetEnabled = function (type) {
            return _this.projectStore.settings.navigation.enabled === type;
        };
        this.enableWidget = function (type) {
            if (type == null) {
                throw new Error(ProjectNavigation.NO_TYPE_GIVEN_ERROR);
            }
            if (!_this.isValidWidgetType(type)) {
                throw new Error(ProjectNavigation.UNSUPPORTED_TYPE_ERROR(type));
            }
            _this.projectStore.setNavigationSettings({ enabled: type });
            _this.telemetry.update({
                navigation_menu_type: type,
            });
        };
        this.enable = function () {
            if (_this.isNavEnabled()) {
                return;
            }
            _this.projectStore.setNavigationSettings({ enabled: ProjectNavigation.DEFAULT_NAVIGATION_MENU });
            _this.telemetry.track("Navigation Enabled", { navigation_menu_type: _this.projectStore.settings.navigation.enabled }, { blockIntercom: true });
            _this.guessBlockNames();
        };
        this.disable = function () {
            _this.projectStore.setNavigationSettings({ enabled: ProjectTypes_1.ProjectNavigationWidgetType.Disabled });
            _this.telemetry.track("Navigation Disabled", { navigation_menu_type: "" });
        };
        this.isNavEnabled = function () {
            return _this.projectStore.settings.navigation.enabled.length > 0;
        };
        this.getWidget = function (type) {
            return _this.projectStore.settings.navigation.widgets[type];
        };
        this.updateShowContact = function (showContact) {
            _this.projectStore.settings.navigation.widgets.header.showContact = showContact;
            _this.projectStore.settings.navigation.widgets.sidebar.showContact = showContact;
            _this.projectStore.setNavigationSettings(_this.projectStore.settings.navigation);
        };
        this.updateWidgetSettings = function (widgetType, settings) {
            if (widgetType == null) {
                throw new Error(ProjectNavigation.NO_TYPE_GIVEN_ERROR);
            }
            if (!_this.isValidWidgetType(widgetType)) {
                throw new Error(ProjectNavigation.UNSUPPORTED_TYPE_ERROR(widgetType));
            }
            if (settings == null) {
                throw new Error(ProjectNavigation.NO_SETTINGS_GIVEN_ERROR);
            }
            return lodash_1.default.assign(_this.projectStore.settings.navigation.widgets[widgetType], settings);
        };
        this.showBlockInNavigation = function (block) {
            if (block == null) {
                throw new Error(ProjectNavigation.NO_BLOCK_GIVEN_ERROR);
            }
            var isBlockBrowser = !(0, IsBlockBrowser_1.isBlockBrowser)(block);
            return isBlockBrowser && block.settings.navigation != null && !block.settings.navigation.exclude;
        };
        this.guessBlockNames = function () {
            var e_1, _a;
            try {
                for (var _b = __values(_this.blockList.blocks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var block = _c.value;
                    if (block.name != null ? block.name.length : undefined) {
                        continue;
                    }
                    else {
                        (0, GuessBlockName_1.guessBlockName)(block);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        };
        this.isValidWidgetType = function (type) {
            return lodash_1.default.includes(ProjectNavigation.WIDGET_TYPES, type);
        };
    }
    ProjectNavigation.NO_TYPE_GIVEN_ERROR = "Was not given a widget type";
    ProjectNavigation.NO_SETTINGS_GIVEN_ERROR = "Was not given any settings to update";
    ProjectNavigation.NO_BLOCK_GIVEN_ERROR = "No block was given";
    ProjectNavigation.UNSUPPORTED_TYPE_ERROR = function (type) { return "Given unknown widget type: ".concat(type); };
    ProjectNavigation.DEFAULT_NAVIGATION_MENU = ProjectTypes_1.ProjectNavigationWidgetType.Header;
    ProjectNavigation.WIDGET_TYPES = [ProjectTypes_1.ProjectNavigationWidgetType.Header, ProjectTypes_1.ProjectNavigationWidgetType.Sidebar];
    return ProjectNavigation;
}());
exports.default = ProjectNavigation;
